// descFlags.js — company-wide "print item description?" switches.
//
// The full DescriptionDisplay config (which surfaces show item descriptions) is
// stored server-side (RestSettings "DescriptionDisplay") and edited in Business
// Settings / item management. It is cached in sessionStorage so the ESC/POS
// BUILDERS — which are synchronous and can't fetch — can read it instantly.
//
// Only the print surfaces are gated here: KOT (kitchenKot), thermal bill
// (printedBill) and the restaurant invoice (invoice). A MISSING flag defaults to
// ON, so nothing stops printing until an admin explicitly turns it off.

const CACHE_KEY = 'descDisplayFlags';

export function setDescFlagsCache(cfg) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(cfg || {}));
  } catch { /* private mode / quota — flags just fall back to defaults */ }
}

export function getDescFlags() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    const c = raw ? JSON.parse(raw) : {};
    return {
      kot: c.kitchenKot !== false,      // print description on the KOT?
      bill: c.printedBill !== false,    // print description on the thermal bill?
      invoice: c.invoice !== false,     // print description on the restaurant invoice?
    };
  } catch {
    return { kot: true, bill: true, invoice: true };
  }
}
